export const VOLUNTEER_EXPERIENCES = [
  {
    organization: "CEG Tech Forum",
    logo: "ctf.png",
    duration: "Dec '21 - Jun '22",
    role: "Student Director of Technical Operations",
    workedIn: "React, ExpressJS, AWS",
    highlights: [
      "Built Kurukshetra'22 tech-fest web app (14,000+ registrations, zero downtime) and mentored 20+ juniors."
    ]
  },
  {
    organization: "Computer Science and Engineering Association, CEG",
    logo: "csea.png",
    duration: "Jan '21 - Mar '21",
    role: "Developer and Organizer",
    workedIn: "React",
    highlights: [
      "Led tech team for Abacus'21 web app, delivering neon-themed UI and reusable components."
    ]
  },
  {
    organization: "Computer Society of Anna University",
    logo: "csau.png",
    duration: "Jun '21 - Jun '22",
    role: "Student Director",
    highlights: [
      "Organized 'Intern Mentor' program, teaching CS basics and guiding 200+ students on internships and research."
    ]
  },
];
